import { getContentCallback } from "./callback";

const SELECTOR = ".js-popup-list";

// переделать бы без callback на прототипирование
function handlePopupList(popupListEl) {
  const btnEl = popupListEl.querySelector(SELECTOR + "-button");
  const textEl = popupListEl.querySelector(SELECTOR + "-text");
  const listEl = popupListEl.querySelector(SELECTOR + "-ul");
  const inputEl = popupListEl.querySelector(SELECTOR + "-input");
  const listItemButtonEls = listEl.querySelectorAll(SELECTOR + "-li-btn");

  if (inputEl) {
    inputEl.addEventListener("input", ({ target }) => {
      const value = target.value.toLowerCase().trim();
      hideNotRelevant(value, listItemButtonEls);
    });
  }

  btnEl.addEventListener("click", () => {
    popupListEl.classList.toggle("active");
  });
  document.addEventListener("click", (event) => {
    if (!event.target.closest(SELECTOR)) {
      popupListEl.classList.remove("active");
    }
  });

  listItemButtonEls.forEach((listItemButtonEl) => {
    listItemButtonEl.addEventListener("click", () =>
      handlePopupListItem({
        listEl,
        listItemButtonEl,
        contentCallback: () =>
          getContentCallback(popupListEl)(textEl, listItemButtonEl),
      })
    );
  });
}

function hideNotRelevant(src, dest) {
  for (const item of dest) {
    item.classList.add("hide");
    if (item.textContent.toLowerCase().trim().includes(src)) {
      item.classList.remove("hide");
    }
  }
}

function handlePopupListItem({ listEl, listItemButtonEl, contentCallback }) {
  const activeListItemButtonEL = listEl.querySelector(
    SELECTOR + "-li-btn.active"
  );

  activeListItemButtonEL?.classList.remove("active");
  listItemButtonEl.classList.add("active");
  listEl.classList.remove("active");
  contentCallback();
}

export function initPopupLists() {
  const popupListEls = document.querySelectorAll(SELECTOR);

  popupListEls.forEach(handlePopupList);
}
